import { getAccessToken } from "../../utils/auth";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { IconButton } from "@mui/material";
import axios from "../../utils/api.js";

const ScanningCenter = () => {
  const [formData, setFormData] = useState({
    centerInfo: {
      centerName: "",
      centerType: "",
      accreditations: "",
      totalFloorArea: 0,
      totalNumberOfRooms: 0,
    },
    dataCollection: {
      date: "",
      collectedBy: [],
      dataSource: "",
    },
    facilityLayout: {
      totalMRImachines: 0,
      totalCTscanners: 0,
      totalXRaymachines: 0,
      totalUltrasoundRooms: 0,
      avgDailyPatientFootfall: 0,
      avgDailyStaffFootfall: 0,
      waitingAreaSize: 0,
      numChangingRooms: 0,
      numPatientBeds: 0,
    },
    cleaningAndDisinfect: {
      totalBudget: 0,
      costScanningRooms: 0,
      costWaitingAreas: 0,
      costChangingRooms: 0,
      costEquipment: 0,
      currentMethods: [],
      frequencyPerDay: 0,
      manualDisinfectionTime: 0,
      challenges: [],
    },
    healthAndSafety: {
      regulatoryStandards: [],
      auditFrequency: [],
      disinfectionComplaints: {
        hasComplaints: false,
        details: [],
      },
    },
    staffAndAutomation: {
      numHousekeepingStaff: 0,
      cleaningShiftHours: 0,
      ppeUsage: false,
      automationReadiness: false,
      uvConcerns: false,
    },
    timeAndCostAnalysis: {
      manualDisinfectionTimePerDay: 0, // hours
      consumableCostPerMonth: 0,
      laborCostPerMonth: 0,
      guestRefundCost: 0,
      electricityConsumption: 0,
    },
    integrationNeeds: {
      existingITSystem: false,
      integrationNeeds: "",
      financialModel: "",
      customizationNeeds: [],
    },
    demoAndNextSteps: {
      onSiteDemoInterest: false,
      pilotProjectReadiness: false,
      keyDecisionMaker: "",
      expectedTimeline: [],
    },
    additionalnotes: {
      note: "",
    },
  });
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(0);

  const FORM_STEPS = [
    "Center Info",
    "Data Collection",
    "Facility Layout",
    "Cleaning & Disinfection",
    "Health & Safety",
    "Staff & Automation",
    "Time & Cost Analysis",
    "Integration Needs",
    "Demo & Next Steps",
    "Additional Notes",
  ];
  const totalSteps = FORM_STEPS.length;

  const pageStyle = {
    position: "relative",
    minHeight: "100vh",
    background:
      "radial-gradient(1200px 600px at 10% 0%, rgba(37, 99, 235, 0.10), rgba(255,255,255,0) 60%), radial-gradient(900px 450px at 90% 15%, rgba(16, 185, 129, 0.10), rgba(255,255,255,0) 55%), #ffffff",
    fontFamily:
      "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    padding: "24px 32px 48px",
    boxSizing: "border-box",
  };
  const cardStyle = {
    maxWidth: 720,
    margin: "0 auto 24px",
    backgroundColor: "#fff",
    border: "1px solid #e2e8f0",
    borderRadius: 14,
    padding: 28,
    boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
  };
  const inputGroupStyle = { marginBottom: 18 };
  const labelStyle = {
    display: "block",
    marginBottom: 6,
    fontWeight: 600,
    fontSize: "0.9rem",
    color: "#64748b",
  };
  const inputStyle = {
    width: "100%",
    padding: "0.65rem 0.85rem",
    borderRadius: 8,
    border: "1px solid #e2e8f0",
    fontSize: "1rem",
    outline: "none",
    boxSizing: "border-box",
  };
  const sectionTitleStyle = {
    margin: "0 0 20px",
    fontSize: "1.1rem",
    fontWeight: 600,
    color: "#1e293b",
  };

  const handleChange = (e, section, nestedSection) => {
    const { name, value, type } = e.target;
    let newValue = value;

    if (type === "number") {
      newValue = Math.max(0, Number(value)) || 0;
    } else if (type === "checkbox") {
      newValue = e.target.checked;
    }

    if (nestedSection) {
      setFormData((prevData) => ({
        ...prevData,
        [section]: {
          ...prevData[section],
          [nestedSection]: {
            ...prevData[section][nestedSection],
            [name]: newValue,
          },
        },
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [section]: {
          ...prevData[section],
          [name]: newValue,
        },
      }));
    }

    // Clear errors when user starts typing
    if (errors[name]) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    }
  };

  const handleArrayChange = (e, section, nestedSection, field) => {
    const { value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [section]: nestedSection
        ? {
            ...prevData[section],
            [nestedSection]: {
              ...prevData[section][nestedSection],
              [field]: value.split(",").map((item) => item.trim()), // Ensure this is an array
            },
          }
        : {
            ...prevData[section],
            [field]: value.split(",").map((item) => item.trim()), // Ensure this is an array
          },
    }));
    // Clear errors when user starts typing
    if (errors[field]) {
      setErrors((prevErrors) => ({ ...prevErrors, [field]: "" }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const token = getAccessToken();
      const response = await axios.post("/post-scanning-center", formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      console.log("Data posted successfully:", response.data);
      alert("Scanning center data submitted successfully!");
      setFormData({
        centerInfo: {
          centerName: "",
          centerType: "",
          accreditations: "",
          totalFloorArea: 0,
          totalNumberOfRooms: 0,
        },
        dataCollection: {
          date: "",
          collectedBy: [],
          dataSource: "",
        },
        facilityLayout: {
          totalMRImachines: 0,
          totalCTscanners: 0,
          totalXRaymachines: 0,
          totalUltrasoundRooms: 0,
          avgDailyPatientFootfall: 0,
          avgDailyStaffFootfall: 0,
          waitingAreaSize: 0,
          numChangingRooms: 0,
          numPatientBeds: 0,
        },
        cleaningAndDisinfect: {
          totalBudget: 0,
          costScanningRooms: 0,
          costWaitingAreas: 0,
          costChangingRooms: 0,
          costEquipment: 0,
          currentMethods: [],
          frequencyPerDay: 0,
          manualDisinfectionTime: 0,
          challenges: [],
        },
        healthAndSafety: {
          regulatoryStandards: [],
          auditFrequency: [],
          disinfectionComplaints: {
            hasComplaints: false,
            details: [],
          },
        },
        staffAndAutomation: {
          numHousekeepingStaff: 0,
          cleaningShiftHours: 0,
          ppeUsage: false,
          automationReadiness: false,
          uvConcerns: false,
        },
        timeAndCostAnalysis: {
          manualDisinfectionTimePerDay: 0, // hours
          consumableCostPerMonth: 0,
          laborCostPerMonth: 0,
          guestRefundCost: 0,
          electricityConsumption: 0,
        },
        integrationNeeds: {
          existingITSystem: false,
          integrationNeeds: "",
          financialModel: "",
          customizationNeeds: [],
        },
        demoAndNextSteps: {
          onSiteDemoInterest: false,
          pilotProjectReadiness: false,
          keyDecisionMaker: "",
          expectedTimeline: [],
        },
        additionalnotes: {
          note: "",
        },
      });
      navigate("/Viewscanningcenter");
    } catch (error) {
      console.error(
        "Error posting data:",
        error.response?.data || error.message
      );
      alert("Failed to submit scanning center data.");
    }
  };

  return (
    <div style={pageStyle}>
      <IconButton
        onClick={() => navigate(-1)}
        style={{
          position: "absolute",
          top: 24,
          left: 24,
          backgroundColor: "rgba(255, 255, 255, 0.9)",
          backdropFilter: "blur(10px)",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
          color: "#4a4a4a",
          zIndex: 10,
        }}
      >
        <ArrowBackIcon />
      </IconButton>

      <div style={{ textAlign: "center", marginTop: 20, marginBottom: 28 }}>
        <h1
          style={{
            margin: 0,
            marginBottom: 8,
            fontSize: "1.85rem",
            fontWeight: 700,
            letterSpacing: "-0.5px",
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
          }}
        >
          Scanning Center Form
        </h1>
        <p
          style={{
            margin: 0,
            fontSize: "0.95rem",
            color: "#64748b",
            fontWeight: 400,
          }}
        >
          Complete the sections below. Use Previous and Next to move between steps.
        </p>
      </div>

      <div
        style={{
          maxWidth: 720,
          margin: "0 auto 20px",
          display: "flex",
          justifyContent: "center",
          flexWrap: "wrap",
          gap: 8,
        }}
      >
        {FORM_STEPS.map((name, i) => (
          <span
            key={i}
            style={{
              padding: "6px 12px",
              borderRadius: 8,
              fontSize: "0.8rem",
              fontWeight: 500,
              background:
                currentStep === i
                  ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                  : "#e2e8f0",
              color: currentStep === i ? "#fff" : "#64748b",
            }}
          >
            {name}
          </span>
        ))}
      </div>

      <form onSubmit={handleSubmit}>
        <div style={cardStyle}>
          {currentStep === 0 && (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 20,
                }}
              >
                <h3 style={sectionTitleStyle}>Center Info</h3>
                <p
                  style={{
                    margin: 0,
                    fontSize: "0.8rem",
                    color: "#64748b",
                    fontWeight: 500,
                  }}
                >
                  Step 1 of {totalSteps}
                </p>
              </div>
          {/* Center Name */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>Center Name</label>
            <input
              type="text"
              name="centerName"
              placeholder="Enter center name"
              value={formData.centerInfo.centerName}
              onChange={(e) => handleChange(e, "centerInfo")}
              style={inputStyle}
            />
            {errors.centerName && (
              <span style={{ color: "#dc2626", fontSize: "0.85rem" }}>{errors.centerName}</span>
            )}
          </div>

          {/* Center Type */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>Center Type</label>
            <select
              name="centerType"
              value={formData.centerInfo.centerType}
              onChange={(e) => handleChange(e, "centerInfo")}
              style={inputStyle}
            >
              <option value="">Select Center Type</option>
              <option value="Standalone">Standalone</option>
              <option value="Hospital-Based">Hospital-Based</option>
              <option value="Chain">Chain</option>
            </select>
            {errors.centerType && (
              <span style={{ color: "#dc2626", fontSize: "0.85rem" }}>{errors.centerType}</span>
            )}
          </div>

          {/* Accreditations */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>Accreditations (comma separated)</label>
            <input
              type="text"
              name="accreditations"
              placeholder="Enter accreditations (e.g., NABL, ISO, JCI)"
              value={
                Array.isArray(formData.centerInfo.accreditations)
                  ? formData.centerInfo.accreditations.join(", ")
                  : ""
              }
              onChange={(e) =>
                handleArrayChange(e, "centerInfo", null, "accreditations")
              }
              style={inputStyle}
            />
            {errors.accreditations && (
              <span style={{ color: "#dc2626", fontSize: "0.85rem" }}>{errors.accreditations}</span>
            )}
          </div>

          {/* Total Floor Area */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>Total Floor Area (sq. ft.)</label>
            <input
              type="number"
              name="totalFloorArea"
              placeholder="Enter total floor area"
              value={formData.centerInfo.totalFloorArea || ""}
              onChange={(e) => handleChange(e, "centerInfo")}
              style={inputStyle}
            />
            {errors.totalFloorArea && (
              <span style={{ color: "#dc2626", fontSize: "0.85rem" }}>{errors.totalFloorArea}</span>
            )}
          </div>

          {/* Total Number of Rooms */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>Total Number of Rooms</label>
            <input
              type="number"
              name="totalNumberOfRooms"
              placeholder="Enter total number of rooms"
              value={formData.centerInfo.totalNumberOfRooms || ""}
              onChange={(e) => handleChange(e, "centerInfo")}
              style={inputStyle}
            />
            {errors.totalNumberOfRooms && (
              <span style={{ color: "#dc2626", fontSize: "0.85rem" }}>{errors.totalNumberOfRooms}</span>
            )}
          </div>
            </>
          )}

          {currentStep === 1 && (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 20,
                }}
              >
                <h3 style={sectionTitleStyle}>Data Collection</h3>
                <p
                  style={{
                    margin: 0,
                    fontSize: "0.8rem",
                    color: "#64748b",
                    fontWeight: 500,
                  }}
                >
                  Step 2 of {totalSteps}
                </p>
              </div>
          <div style={inputGroupStyle}>
            <label style={labelStyle}>Date</label>
            <input
              type="date"
              name="date"
              value={formData.dataCollection.date}
              onChange={(e) => handleChange(e, "dataCollection")}
              style={inputStyle}
            />
            {errors.date && <span style={{ color: "#dc2626", fontSize: "0.85rem" }}>{errors.date}</span>}
          </div>
          <div style={inputGroupStyle}>
            <label style={labelStyle}>Collected By (comma-separated)</label>
            <input
              type="text"
              name="collectedBy"
              placeholder="Enter names separated by commas"
              value={formData.dataCollection.collectedBy.join(",")} // Ensure collectedBy is an array
              onChange={(e) =>
                handleArrayChange(e, "dataCollection", null, "collectedBy")
              }
              style={inputStyle}
            />
            {errors.collectedBy && (
              <span style={{ color: "#dc2626", fontSize: "0.85rem" }}>{errors.collectedBy}</span>
            )}
          </div>
          <div style={inputGroupStyle}>
            <label style={labelStyle}>Data Source</label>
            <select
              name="dataSource"
              value={formData.dataCollection.dataSource}
              onChange={(e) => handleChange(e, "dataCollection")}
              style={inputStyle}
            >
              <option value="">Select Data Source</option>
              <option value="Facility Manager">Facility Manager</option>
              <option value="Radiology Dept.">Radiology Dept.</option>
              <option value="Admin">Admin</option>
            </select>
            {errors.dataSource && (
              <span style={{ color: "#dc2626", fontSize: "0.85rem" }}>{errors.dataSource}</span>
            )}
          </div>
            </>
          )}

          {currentStep === 2 && (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 20,
                }}
              >
                <h3 style={sectionTitleStyle}>Facility Layout</h3>
                <p
                  style={{
                    margin: 0,
                    fontSize: "0.8rem",
                    color: "#64748b",
                    fontWeight: 500,
                  }}
                >
                  Step 3 of {totalSteps}
                </p>
              </div>
          {[
            { label: "Total MRI Machines", name: "totalMRImachines" },
            { label: "Total CT Scanners", name: "totalCTscanners" },
            { label: "Total X-Ray Machines", name: "totalXRaymachines" },
            { label: "Total Ultrasound Rooms", name: "totalUltrasoundRooms" },
            {
              label: "Avg Daily Patient Footfall",
              name: "avgDailyPatientFootfall",
            },
            {
              label: "Avg Daily Staff Footfall",
              name: "avgDailyStaffFootfall",
            },
            { label: "Waiting Area Size (sq. ft.)", name: "waitingAreaSize" },
            { label: "Number of Changing Rooms", name: "numChangingRooms" },
            { label: "Number of Patient Beds", name: "numPatientBeds" },
          ].map(({ label, name }, index) => (
            <div style={inputGroupStyle} key={index}>
              <label style={labelStyle}>{label}</label>
              <input
                type="number"
                name={name}
                placeholder={`Enter ${label.toLowerCase()}`}
                value={formData.facilityLayout[name] || ""}
                onChange={(e) => handleChange(e, "facilityLayout")}
                style={inputStyle}
              />
            </div>
          ))}
            </>
          )}

          {currentStep === 3 && (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 20,
                }}
              >
                <h3 style={sectionTitleStyle}>Cleaning & Disinfection</h3>
                <p
                  style={{
                    margin: 0,
                    fontSize: "0.8rem",
                    color: "#64748b",
                    fontWeight: 500,
                  }}
                >
                  Step 4 of {totalSteps}
                </p>
              </div>
          {/* Dynamically render input fields */}
          {[
            {
              label: "Total Budget (₹)",
              name: "totalBudget",
              placeholder: "Enter total budget in ₹",
              type: "number",
              error: errors.totalBudget,
            },
            {
              label: "Cost for Scanning Rooms (%)",
              name: "costScanningRooms",
              placeholder: "Enter cost percentage",
              type: "number",
            },
            {
              label: "Cost for Waiting Areas (%)",
              name: "costWaitingAreas",
              placeholder: "Enter cost percentage",
              type: "number",
            },
            {
              label: "Cost for Changing Rooms (%)",
              name: "costChangingRooms",
              placeholder: "Enter cost percentage",
              type: "number",
            },
            {
              label: "Cost for Equipment (%)",
              name: "costEquipment",
              placeholder: "Enter cost percentage",
              type: "number",
            },
            {
              label: "Frequency of Cleaning per Day",
              name: "frequencyPerDay",
              placeholder: "Enter times per day",
              type: "number",
              error: errors.frequencyPerDay,
            },
            {
              label: "Manual Disinfection Time (minutes)",
              name: "manualDisinfectionTime",
              placeholder: "Enter time in minutes",
              type: "number",
              error: errors.manualDisinfectionTime,
            },
          ].map(({ label, name, placeholder, type, error }, index) => (
            <div style={inputGroupStyle} key={index}>
              <label style={labelStyle}>{label}</label>
              <input
                type={type}
                name={name}
                placeholder={placeholder}
                value={formData.cleaningAndDisinfect[name] || ""}
                onChange={(e) => handleChange(e, "cleaningAndDisinfect")}
                style={inputStyle}
              />
              {error && <span style={{ color: "#dc2626", fontSize: "0.85rem" }}>{error}</span>}
            </div>
          ))}

          {/* Current Cleaning Methods */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>
              Current Cleaning Methods (comma separated)
            </label>
            <input
              type="text"
              name="currentMethods"
              placeholder="Enter cleaning methods (e.g., UV, manual, chemicals)"
              value={
                formData.cleaningAndDisinfect.currentMethods.join(", ") || ""
              }
              onChange={(e) =>
                handleArrayChange(
                  e,
                  "cleaningAndDisinfect",
                  null,
                  "currentMethods"
                )
              }
              style={inputStyle}
            />
            {errors.currentMethods && (
              <span style={{ color: "#dc2626", fontSize: "0.85rem" }}>{errors.currentMethods}</span>
            )}
          </div>
          <div style={inputGroupStyle}>
            <label style={labelStyle}>Challenges (comma separated)</label>
            <input
              type="text"
              name="challenges"
              placeholder="Enter challenges faced (e.g., high cost, time-consuming)"
              value={formData.cleaningAndDisinfect.challenges.join(", ") || ""}
              onChange={(e) =>
                handleArrayChange(e, "cleaningAndDisinfect", null, "challenges")
              }
              style={inputStyle}
            />
            {errors.challenges && (
              <span style={{ color: "#dc2626", fontSize: "0.85rem" }}>{errors.challenges}</span>
            )}
          </div>
            </>
          )}

          {currentStep === 4 && (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 20,
                }}
              >
                <h3 style={sectionTitleStyle}>Health & Safety</h3>
                <p
                  style={{
                    margin: 0,
                    fontSize: "0.8rem",
                    color: "#64748b",
                    fontWeight: 500,
                  }}
                >
                  Step 5 of {totalSteps}
                </p>
              </div>
          {/* Regulatory Standards */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>
              Regulatory Standards (comma separated)
            </label>
            <input
              type="text"
              name="regulatoryStandards"
              placeholder="Enter regulatory standards (e.g., WHO, Local Govt., NABH)"
              value={
                formData.healthAndSafety.regulatoryStandards.join(", ") || ""
              }
              onChange={(e) =>
                handleArrayChange(
                  e,
                  "healthAndSafety",
                  null,
                  "regulatoryStandards"
                )
              }
              style={inputStyle}
            />
            {errors.regulatoryStandards && (
              <span style={{ color: "#dc2626", fontSize: "0.85rem" }}>{errors.regulatoryStandards}</span>
            )}
          </div>

          {/* Audit Frequency */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>
              Audit Frequency (comma separated)
            </label>
            <input
              type="text"
              name="auditFrequency"
              placeholder="Enter audit frequency (e.g., Quarterly, Annually)"
              value={formData.healthAndSafety.auditFrequency.join(", ") || ""}
              onChange={(e) =>
                handleArrayChange(e, "healthAndSafety", null, "auditFrequency")
              }
              style={inputStyle}
            />
            {errors.auditFrequency && (
              <span style={{ color: "#dc2626", fontSize: "0.85rem" }}>{errors.auditFrequency}</span>
            )}
          </div>

          {/* Disinfection Complaints */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>Has Disinfection Complaints?</label>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "20px",
              }}
            >
              <label
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                <input
                  type="radio"
                  name="hasComplaints"
                  value="true"
                  checked={
                    formData.healthAndSafety.disinfectionComplaints
                      .hasComplaints === true
                  }
                  onChange={() =>
                    setFormData((prevData) => ({
                      ...prevData,
                      healthAndSafety: {
                        ...prevData.healthAndSafety,
                        disinfectionComplaints: {
                          ...prevData.healthAndSafety.disinfectionComplaints,
                          hasComplaints: true, // Set to true when selected
                        },
                      },
                    }))
                  }
                  style={{ width: "18px", height: "18px", cursor: "pointer" }}
                />
                <span style={{ fontWeight: "bold", color: "green" }}>True</span>
              </label>

              <label
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                <input
                  type="radio"
                  name="hasComplaints"
                  value="false"
                  checked={
                    formData.healthAndSafety.disinfectionComplaints
                      .hasComplaints === false
                  }
                  onChange={() =>
                    setFormData((prevData) => ({
                      ...prevData,
                      healthAndSafety: {
                        ...prevData.healthAndSafety,
                        disinfectionComplaints: {
                          ...prevData.healthAndSafety.disinfectionComplaints,
                          hasComplaints: false, // Set to false when selected
                          details: [], // Reset details if false
                        },
                      },
                    }))
                  }
                  style={{ width: "18px", height: "18px", cursor: "pointer" }}
                />
                <span style={{ fontWeight: "bold", color: "red" }}>False</span>
              </label>
            </div>
          </div>

          {/* Disinfection Complaints Details */}
          {formData.healthAndSafety.disinfectionComplaints.hasComplaints && (
            <div style={inputGroupStyle}>
              <label style={labelStyle}>
                Disinfection Complaints Details (comma separated)
              </label>
              <input
                type="text"
                name="details"
                placeholder="Enter details of complaints"
                value={
                  formData.healthAndSafety.disinfectionComplaints.details.join(
                    ", "
                  ) || ""
                }
                onChange={(e) =>
                  handleArrayChange(
                    e,
                    "healthAndSafety",
                    "disinfectionComplaints",
                    "details"
                  )
                }
                style={inputStyle}
              />
              {errors.details && (
                <span style={{ color: "#dc2626", fontSize: "0.85rem" }}>{errors.details}</span>
              )}
            </div>
          )}
            </>
          )}

          {currentStep === 5 && (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 20,
                }}
              >
                <h3 style={sectionTitleStyle}>Staff & Automation</h3>
                <p
                  style={{
                    margin: 0,
                    fontSize: "0.8rem",
                    color: "#64748b",
                    fontWeight: 500,
                  }}
                >
                  Step 6 of {totalSteps}
                </p>
              </div>
          {/* Number of Housekeeping Staff */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>Number of Housekeeping Staff</label>
            <input
              type="number"
              name="numHousekeepingStaff"
              placeholder="Enter number of housekeeping staff"
              value={formData.staffAndAutomation.numHousekeepingStaff || ""}
              onChange={(e) => handleChange(e, "staffAndAutomation")}
              style={inputStyle}
            />
            {errors.numHousekeepingStaff && (
              <span style={{ color: "#dc2626", fontSize: "0.85rem" }}>{errors.numHousekeepingStaff}</span>
            )}
          </div>

          {/* Cleaning Shift Hours */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>Cleaning Shift Hours</label>
            <input
              type="number"
              name="cleaningShiftHours"
              placeholder="Enter cleaning shift hours"
              value={formData.staffAndAutomation.cleaningShiftHours || ""}
              onChange={(e) => handleChange(e, "staffAndAutomation")}
              style={inputStyle}
            />
            {errors.cleaningShiftHours && (
              <span style={{ color: "#dc2626", fontSize: "0.85rem" }}>{errors.cleaningShiftHours}</span>
            )}
          </div>

          {/* PPE Usage */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>PPE Usage</label>
            <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
              <label
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                <input
                  type="radio"
                  name="ppeUsage"
                  value="true"
                  checked={formData.staffAndAutomation.ppeUsage === true}
                  onChange={() =>
                    setFormData((prevData) => ({
                      ...prevData,
                      staffAndAutomation: {
                        ...prevData.staffAndAutomation,
                        ppeUsage: true,
                      },
                    }))
                  }
                  style={{ width: "18px", height: "18px", cursor: "pointer" }}
                />
                <span style={{ fontWeight: "bold", color: "green" }}>True</span>
              </label>

              <label
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                <input
                  type="radio"
                  name="ppeUsage"
                  value="false"
                  checked={formData.staffAndAutomation.ppeUsage === false}
                  onChange={() =>
                    setFormData((prevData) => ({
                      ...prevData,
                      staffAndAutomation: {
                        ...prevData.staffAndAutomation,
                        ppeUsage: false,
                      },
                    }))
                  }
                  style={{ width: "18px", height: "18px", cursor: "pointer" }}
                />
                <span style={{ fontWeight: "bold", color: "red" }}>False</span>
              </label>
            </div>
          </div>

          {/* Automation Readiness */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>Automation Readiness</label>
            <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
              <label
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                <input
                  type="radio"
                  name="automationReadiness"
                  value="true"
                  checked={
                    formData.staffAndAutomation.automationReadiness === true
                  }
                  onChange={() =>
                    setFormData((prevData) => ({
                      ...prevData,
                      staffAndAutomation: {
                        ...prevData.staffAndAutomation,
                        automationReadiness: true,
                      },
                    }))
                  }
                  style={{ width: "18px", height: "18px", cursor: "pointer" }}
                />
                <span style={{ fontWeight: "bold", color: "green" }}>True</span>
              </label>

              <label
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                <input
                  type="radio"
                  name="automationReadiness"
                  value="false"
                  checked={
                    formData.staffAndAutomation.automationReadiness === false
                  }
                  onChange={() =>
                    setFormData((prevData) => ({
                      ...prevData,
                      staffAndAutomation: {
                        ...prevData.staffAndAutomation,
                        automationReadiness: false,
                      },
                    }))
                  }
                  style={{ width: "18px", height: "18px", cursor: "pointer" }}
                />
                <span style={{ fontWeight: "bold", color: "red" }}>False</span>
              </label>
            </div>
          </div>

          {/* UV Concerns */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>UV Concerns</label>
            <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
              <label
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                <input
                  type="radio"
                  name="uvConcerns"
                  value="true"
                  checked={formData.staffAndAutomation.uvConcerns === true}
                  onChange={() =>
                    setFormData((prevData) => ({
                      ...prevData,
                      staffAndAutomation: {
                        ...prevData.staffAndAutomation,
                        uvConcerns: true,
                      },
                    }))
                  }
                  style={{ width: "18px", height: "18px", cursor: "pointer" }}
                />
                <span style={{ fontWeight: "bold", color: "green" }}>True</span>
              </label>

              <label
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                <input
                  type="radio"
                  name="uvConcerns"
                  value="false"
                  checked={formData.staffAndAutomation.uvConcerns === false}
                  onChange={() =>
                    setFormData((prevData) => ({
                      ...prevData,
                      staffAndAutomation: {
                        ...prevData.staffAndAutomation,
                        uvConcerns: false,
                      },
                    }))
                  }
                  style={{ width: "18px", height: "18px", cursor: "pointer" }}
                />
                <span style={{ fontWeight: "bold", color: "red" }}>False</span>
              </label>
            </div>
          </div>
            </>
          )}

          {currentStep === 6 && (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 20,
                }}
              >
                <h3 style={sectionTitleStyle}>Time & Cost Analysis</h3>
                <p
                  style={{
                    margin: 0,
                    fontSize: "0.8rem",
                    color: "#64748b",
                    fontWeight: 500,
                  }}
                >
                  Step 7 of {totalSteps}
                </p>
              </div>
          {/* Manual Disinfection Time Per Day */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>
              Manual Disinfection Time Per Day (hours)
            </label>
            <input
              type="number"
              name="manualDisinfectionTimePerDay"
              placeholder="Enter manual disinfection time per day"
              value={
                formData.timeAndCostAnalysis.manualDisinfectionTimePerDay || ""
              }
              onChange={(e) => handleChange(e, "timeAndCostAnalysis")}
              style={inputStyle}
            />
            {errors.manualDisinfectionTimePerDay && (
              <span style={{ color: "#dc2626", fontSize: "0.85rem" }}>
                {errors.manualDisinfectionTimePerDay}
              </span>
            )}
          </div>

          {/* Consumable Cost Per Month */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>Consumable Cost Per Month</label>
            <input
              type="number"
              name="consumableCostPerMonth"
              placeholder="Enter consumable cost per month"
              value={formData.timeAndCostAnalysis.consumableCostPerMonth || ""}
              onChange={(e) => handleChange(e, "timeAndCostAnalysis")}
              style={inputStyle}
            />
            {errors.consumableCostPerMonth && (
              <span style={{ color: "#dc2626", fontSize: "0.85rem" }}>{errors.consumableCostPerMonth}</span>
            )}
          </div>

          {/* Labor Cost Per Month */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>Labor Cost Per Month</label>
            <input
              type="number"
              name="laborCostPerMonth"
              placeholder="Enter labor cost per month"
              value={formData.timeAndCostAnalysis.laborCostPerMonth || ""}
              onChange={(e) => handleChange(e, "timeAndCostAnalysis")}
              style={inputStyle}
            />
            {errors.laborCostPerMonth && (
              <span style={{ color: "#dc2626", fontSize: "0.85rem" }}>{errors.laborCostPerMonth}</span>
            )}
          </div>

          {/* Guest Refund Cost */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>Guest Refund Cost</label>
            <input
              type="number"
              name="guestRefundCost"
              placeholder="Enter guest refund cost"
              value={formData.timeAndCostAnalysis.guestRefundCost || ""}
              onChange={(e) => handleChange(e, "timeAndCostAnalysis")}
              style={inputStyle}
            />
            {errors.guestRefundCost && (
              <span style={{ color: "#dc2626", fontSize: "0.85rem" }}>{errors.guestRefundCost}</span>
            )}
          </div>

          {/* Electricity Consumption */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>Electricity Consumption</label>
            <input
              type="number"
              name="electricityConsumption"
              placeholder="Enter electricity consumption"
              value={formData.timeAndCostAnalysis.electricityConsumption || ""}
              onChange={(e) => handleChange(e, "timeAndCostAnalysis")}
              style={inputStyle}
            />
            {errors.electricityConsumption && (
              <span style={{ color: "#dc2626", fontSize: "0.85rem" }}>{errors.electricityConsumption}</span>
            )}
          </div>
            </>
          )}

          {currentStep === 7 && (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 20,
                }}
              >
                <h3 style={sectionTitleStyle}>Integration Needs</h3>
                <p
                  style={{
                    margin: 0,
                    fontSize: "0.8rem",
                    color: "#64748b",
                    fontWeight: 500,
                  }}
                >
                  Step 8 of {totalSteps}
                </p>
              </div>

          {/* Existing IT System */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>Existing IT System</label>
            <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
              <label
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                <input
                  type="radio"
                  name="existingITSystem"
                  value="true"
                  checked={formData.integrationNeeds.existingITSystem === true}
                  onChange={() =>
                    setFormData((prevData) => ({
                      ...prevData,
                      integrationNeeds: {
                        ...prevData.integrationNeeds,
                        existingITSystem: true,
                      },
                    }))
                  }
                  style={{ width: "18px", height: "18px", cursor: "pointer" }}
                />
                <span style={{ fontWeight: "bold", color: "green" }}>True</span>
              </label>

              <label
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                <input
                  type="radio"
                  name="existingITSystem"
                  value="false"
                  checked={formData.integrationNeeds.existingITSystem === false}
                  onChange={() =>
                    setFormData((prevData) => ({
                      ...prevData,
                      integrationNeeds: {
                        ...prevData.integrationNeeds,
                        existingITSystem: false,
                      },
                    }))
                  }
                  style={{ width: "18px", height: "18px", cursor: "pointer" }}
                />
                <span style={{ fontWeight: "bold", color: "red" }}>False</span>
              </label>
            </div>
          </div>

          {/* Integration Needs */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>Integration Needs</label>
            <select
              name="integrationNeeds"
              value={formData.integrationNeeds.integrationNeeds || ""}
              onChange={(e) => handleChange(e, "integrationNeeds")}
              style={inputStyle}
            >
              <option value="">Select Integration Needs</option>
              <option value="App Control">App Control</option>
              <option value="Scheduling">Scheduling</option>
              <option value="Alerts">Alerts</option>
            </select>
            {errors.integrationNeeds && (
              <span style={{ color: "#dc2626", fontSize: "0.85rem" }}>{errors.integrationNeeds}</span>
            )}
          </div>

          {/* Financial Model */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>Financial Model</label>
            <select
              name="financialModel"
              value={formData.integrationNeeds.financialModel || ""}
              onChange={(e) => handleChange(e, "integrationNeeds")}
              style={inputStyle}
            >
              <option value="">Select Financial Model</option>
              <option value="Buy">Buy</option>
              <option value="Lease">Lease</option>
              <option value="Subscription">Subscription</option>
            </select>
            {errors.financialModel && (
              <span style={{ color: "#dc2626", fontSize: "0.85rem" }}>{errors.financialModel}</span>
            )}
          </div>

          {/* Customization Needs */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>
              Customization Needs (comma separated)
            </label>
            <input
              type="text"
              name="customizationNeeds"
              placeholder="Enter customization needs (e.g., UI Changes, API Integration)"
              value={
                formData.integrationNeeds.customizationNeeds.join(", ") || ""
              }
              onChange={(e) =>
                handleArrayChange(
                  e,
                  "integrationNeeds",
                  null,
                  "customizationNeeds"
                )
              }
              style={inputStyle}
            />
            {errors.customizationNeeds && (
              <span style={{ color: "#dc2626", fontSize: "0.85rem" }}>{errors.customizationNeeds}</span>
            )}
          </div>
            </>
          )}

          {currentStep === 8 && (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 20,
                }}
              >
                <h3 style={sectionTitleStyle}>Demo & Next Steps</h3>
                <p
                  style={{
                    margin: 0,
                    fontSize: "0.8rem",
                    color: "#64748b",
                    fontWeight: 500,
                  }}
                >
                  Step 9 of {totalSteps}
                </p>
              </div>
          {/* On-Site Demo Interest */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>On-Site Demo Interest</label>
            <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
              <label
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                <input
                  type="radio"
                  name="onSiteDemoInterest"
                  value="true"
                  checked={
                    formData.demoAndNextSteps.onSiteDemoInterest === true
                  }
                  onChange={() =>
                    setFormData((prevData) => ({
                      ...prevData,
                      demoAndNextSteps: {
                        ...prevData.demoAndNextSteps,
                        onSiteDemoInterest: true,
                      },
                    }))
                  }
                  style={{ width: "18px", height: "18px", cursor: "pointer" }}
                />
                <span style={{ fontWeight: "bold", color: "green" }}>True</span>
              </label>

              <label
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                <input
                  type="radio"
                  name="onSiteDemoInterest"
                  value="false"
                  checked={
                    formData.demoAndNextSteps.onSiteDemoInterest === false
                  }
                  onChange={() =>
                    setFormData((prevData) => ({
                      ...prevData,
                      demoAndNextSteps: {
                        ...prevData.demoAndNextSteps,
                        onSiteDemoInterest: false,
                      },
                    }))
                  }
                  style={{ width: "18px", height: "18px", cursor: "pointer" }}
                />
                <span style={{ fontWeight: "bold", color: "red" }}>False</span>
              </label>
            </div>
          </div>

          {/* Pilot Project Readiness */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>Pilot Project Readiness</label>
            <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
              <label
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                <input
                  type="radio"
                  name="pilotProjectReadiness"
                  value="true"
                  checked={
                    formData.demoAndNextSteps.pilotProjectReadiness === true
                  }
                  onChange={() =>
                    setFormData((prevData) => ({
                      ...prevData,
                      demoAndNextSteps: {
                        ...prevData.demoAndNextSteps,
                        pilotProjectReadiness: true,
                      },
                    }))
                  }
                  style={{ width: "18px", height: "18px", cursor: "pointer" }}
                />
                <span style={{ fontWeight: "bold", color: "green" }}>True</span>
              </label>

              <label
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                <input
                  type="radio"
                  name="pilotProjectReadiness"
                  value="false"
                  checked={
                    formData.demoAndNextSteps.pilotProjectReadiness === false
                  }
                  onChange={() =>
                    setFormData((prevData) => ({
                      ...prevData,
                      demoAndNextSteps: {
                        ...prevData.demoAndNextSteps,
                        pilotProjectReadiness: false,
                      },
                    }))
                  }
                  style={{ width: "18px", height: "18px", cursor: "pointer" }}
                />
                <span style={{ fontWeight: "bold", color: "red" }}>False</span>
              </label>
            </div>
          </div>

          {/* Key Decision Maker */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>Key Decision Maker</label>
            <select
              name="keyDecisionMaker"
              value={formData.demoAndNextSteps.keyDecisionMaker || ""}
              onChange={(e) => handleChange(e, "demoAndNextSteps")}
              style={inputStyle}
            >
              <option value="">Select Key Decision Maker</option>
              <option value="Admin">Admin</option>
              <option value="Radiologist">Radiologist</option>
              <option value="Facility Manager">Facility Manager</option>
            </select>
            {errors.keyDecisionMaker && (
              <span style={{ color: "#dc2626", fontSize: "0.85rem" }}>{errors.keyDecisionMaker}</span>
            )}
          </div>

          {/* Expected Timeline */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>
              Expected Timeline (comma separated)
            </label>
            <input
              type="text"
              name="expectedTimeline"
              placeholder="Enter expected timeline (e.g., Q1 2024, Q2 2024)"
              value={
                formData.demoAndNextSteps.expectedTimeline.join(", ") || ""
              }
              onChange={(e) =>
                handleArrayChange(
                  e,
                  "demoAndNextSteps",
                  null,
                  "expectedTimeline"
                )
              }
              style={inputStyle}
            />
            {errors.expectedTimeline && (
              <span style={{ color: "#dc2626", fontSize: "0.85rem" }}>{errors.expectedTimeline}</span>
            )}
          </div>
            </>
          )}

          {currentStep === 9 && (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 20,
                }}
              >
                <h3 style={sectionTitleStyle}>Additional Notes</h3>
                <p
                  style={{
                    margin: 0,
                    fontSize: "0.8rem",
                    color: "#64748b",
                    fontWeight: 500,
                  }}
                >
                  Step 10 of {totalSteps}
                </p>
              </div>
          <div style={inputGroupStyle}>
            <label style={labelStyle}>Notes</label>
            <textarea
              name="note"
              value={formData.additionalnotes.note}
              onChange={(e) => handleChange(e, "additionalnotes")}
              style={{
                width: "100%",
                minHeight: 120,
                padding: "0.65rem 0.85rem",
                borderRadius: 8,
                border: "1px solid #e2e8f0",
                fontSize: "1rem",
                outline: "none",
                boxSizing: "border-box",
                resize: "vertical",
              }}
              placeholder="Enter any additional notes here..."
            />
          </div>
            </>
          )}
        </div>

        <div
          style={{
            maxWidth: 720,
            margin: "0 auto",
            display: "flex",
            alignItems: "center",
            justifyContent:
              currentStep === 0 ? "flex-end" : "space-between",
            gap: 12,
            flexWrap: "wrap",
          }}
        >
          {currentStep > 0 ? (
            <button
              type="button"
              onClick={() => setCurrentStep((s) => s - 1)}
              style={{
                padding: "0.65rem 1.25rem",
                fontSize: "1rem",
                fontWeight: 600,
                color: "#64748b",
                background: "#fff",
                border: "1px solid #e2e8f0",
                borderRadius: 8,
                cursor: "pointer",
                boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
              }}
            >
              Previous
            </button>
          ) : (
            <span />
          )}
          {currentStep < totalSteps - 1 ? (
            <button
              type="button"
              onClick={() => setCurrentStep((s) => s + 1)}
              style={{
                padding: "0.65rem 1.25rem",
                fontSize: "1rem",
                fontWeight: 600,
                background:
                  "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                color: "#fff",
                border: "none",
                borderRadius: 8,
                cursor: "pointer",
                boxShadow: "0 2px 8px rgba(102, 126, 234, 0.3)",
              }}
            >
              Next
            </button>
          ) : (
            <button
              type="submit"
              style={{
                padding: "0.65rem 1.25rem",
                fontSize: "1rem",
                fontWeight: 600,
                background:
                  "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                color: "#fff",
                border: "none",
                borderRadius: 8,
                cursor: "pointer",
                boxShadow: "0 2px 8px rgba(102, 126, 234, 0.3)",
              }}
            >
              Submit
            </button>
          )}
        </div>
      </form>
    </div>
  );
};

export default ScanningCenter;
